import { DocumentCheckIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedLoRGenerationAuditEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface DocumentLoRGenerationAuditEventProps {
  event: DiscriminatedLoRGenerationAuditEvent;
}

export const DocumentLoRGenerationAuditEvent: React.FC<
  DocumentLoRGenerationAuditEventProps
> = ({ event }) => {
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-indigo-100">
          <DocumentCheckIcon className="h-4 w-4 text-indigo-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityDescription>
        <div className="text-sm text-gray-600">
          Letter of Representation generated
        </div>
      </ActivityDescription>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="LoR Generated"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
